interface Insight {
  title: string;
  severity: 'critical' | 'warning' | 'opportunity';
  description: string;
  metric?: string;
  change?: string;
}

interface InsightCardProps {
  insight: Insight;
  onAction: (prompt: string) => void;
}

const SEVERITY_CONFIG = {
  critical: { label: 'Critical', className: 'insight-severity-critical' },
  warning: { label: 'Warning', className: 'insight-severity-warning' },
  opportunity: { label: 'Opportunity', className: 'insight-severity-opportunity' },
};

export type { Insight };

export default function InsightCard({ insight, onAction }: InsightCardProps) {
  const sev = SEVERITY_CONFIG[insight.severity] || SEVERITY_CONFIG.warning;

  return (
    <div className={`insight-card ${sev.className}`}>
      <div className="insight-card-header">
        <span className={`insight-severity-badge ${sev.className}`}>{sev.label}</span>
        {insight.metric && <span className="insight-metric">{insight.metric}</span>}
        {insight.change && <span className="insight-change">{insight.change}</span>}
      </div>
      <h4 className="insight-card-title">{insight.title}</h4>
      <p className="insight-card-desc">{insight.description}</p>
      <div className="insight-card-actions">
        <button
          className="insight-action-btn"
          onClick={() => onAction(`Show me the details for this issue: ${insight.title}`)}
        >
          View
        </button>
        <button
          className="insight-action-btn"
          onClick={() => onAction(`What specific changes would fix: ${insight.title}`)}
        >
          Fix
        </button>
        <button
          className="insight-action-btn insight-action-secondary"
          onClick={() => onAction(`Explain the root cause of: ${insight.title}`)}
        >
          Ask why
        </button>
      </div>
    </div>
  );
}
